export const EDIT_DEBIT_CARD = 'page/EDIT_DEBIT_CARD';
export const EDIT_DEBIT_CARD_COMPLETED = `${EDIT_DEBIT_CARD} [completed]`;
export const EDITING_DEBIT_CARD = 'page/EDITING_DEBIT_CARD';

export const DELETE_DEBIT_CARD = 'page/DELETE_DEBIT_CARD';
export const DELETE_DEBIT_CARD_PENDING = `${DELETE_DEBIT_CARD} [pending]`;

export const UPDATE_DEBIT_CARD = 'page/UPDATE_DEBIT_CARD';
export const UPDATE_DEBIT_CARD_PENDING = `${UPDATE_DEBIT_CARD} [pending]`;

export const SELECT_REPAYMENT_ROLE = 'page/SELECT_REPAYMENT_ROLE';

export const UPDATE_BANK_ACCOUNT = 'page/UPDATE_BANK_ACCOUNT';
